import React from 'react';
import { TablePagination } from '@material-ui/core';

const userPrefs = {
    rowsPerPageOptions: [10, 25, 100]
};

const PaginationRoot = ({
    queryCount,
    page,
    handleChangePage,
    rowsPerPage,
    handleChangeRowsPerPage
}) => {

    return (
        <div>
            <TablePagination
                rowsPerPageOptions={userPrefs.rowsPerPageOptions}
                component="div"
                count={queryCount}
                page={page}
                onChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                backIconButtonProps={{
                'aria-label': 'previous page'
                }}
                nextIconButtonProps={{
                'aria-label': 'next page'
                }}
                labelRowsPerPage={'Documents per page'}
            />
        </div>
    );
};

export default PaginationRoot;

